import httpService from './httpService'

const serverPath = window.location.origin
const arsmoApi = '/arsmo_api'

const schedulerService = {
  getSupportAppointment: (params) => {
    const url = `${serverPath}${arsmoApi}/appointments`
    return httpService.httpGet(url, params)
  },
  getSchedulers: (params) => {
    const url = `${serverPath}${arsmoApi}/schedulers`
    return httpService.httpGet(url, params)
  },
  getExpertFreeTime: (params) => {
    const url = `${serverPath}${arsmoApi}/scheduler/expert_spare_time`
    return httpService.httpGet(url, params)
  },
  addSchedulers: (params) => {
    const url = `${serverPath}${arsmoApi}/schedulers`
    return httpService.httpPost(url, params)
  }
}

export default schedulerService



// WEBPACK FOOTER //
// ./src/services/scheduler-service.js